// src/workspace-developer/adminWorkspaceDeveloperApi.ts
import { apiClient } from "@maat/api-base";
var adminWorkspaceDeveloperApi = {
  /** One workspace's state, for the Workspace detail page's Developer tab. */
  status: async (workspaceId) => apiClient.get(
    `/main/api/admin/workspaces/${encodeURIComponent(workspaceId)}/developer-access`
  ),
  /** The open queue — requested, not yet accepted or declined. Oldest first. */
  listRequests: async (params) => apiClient.get("/main/api/admin/workspaces/developer-access/requests", { params }),
  /**
   * Accept. Mints the paired sandbox in the same transaction; does NOT grant
   * access — the host still owes a signature before any key exists.
   */
  accept: async (workspaceId) => apiClient.post(
    `/main/api/admin/workspaces/${encodeURIComponent(workspaceId)}/developer-access/accept`
  ),
  /** Not terminal — a re-request clears `declined_*`. */
  decline: async (workspaceId, data) => apiClient.post(
    `/main/api/admin/workspaces/${encodeURIComponent(workspaceId)}/developer-access/decline`,
    data
  ),
  /**
   * Suspends the DEVELOPER ROW, never the workspace; the pair is not deleted. A POST
   * with a body rather than a DELETE carrying one, because a revocation RECORDS a
   * reason a reviewer reads later and a body on a DELETE is dropped by enough of the
   * stack that it could silently never arrive. `409 { code: 'not_accepted' }` on a
   * row that was never accepted — a `requested` row is DECLINED, not revoked.
   */
  revoke: async (workspaceId, data) => apiClient.post(
    `/main/api/admin/workspaces/${encodeURIComponent(workspaceId)}/developer-access/revoke`,
    data
  ),
  /**
   * Lift a revocation. No body — the audit row records who did it. The row goes back
   * to where it WAS, not to a fixed state: an unsigned one returns to `accepted`
   * (the host still owes a signature), a signed one to `active`.
   * `404 { code: 'not_found' }` when there is no developer row at all;
   * `409 { code: 'not_revoked' }` when there is nothing to lift.
   */
  reinstate: async (workspaceId) => apiClient.post(
    `/main/api/admin/workspaces/${encodeURIComponent(workspaceId)}/developer-access/reinstate`
  ),
  /** Production and sandbox keys, revoked included. `{ keys: [] }` with no developer row. */
  keys: async (workspaceId) => apiClient.get(
    `/main/api/admin/workspaces/${encodeURIComponent(workspaceId)}/developer-access/keys`
  ),
  /**
   * One key's hourly gateway ceiling. `keyId` is the key ROW id, not its public handle.
   * `null` clears the override back to the platform default. 404 for a key not bound to
   * this workspace's developer row, revoked keys included.
   */
  setKeyRateLimit: async (workspaceId, keyId, data) => apiClient.patch(
    `/main/api/admin/workspaces/${encodeURIComponent(workspaceId)}/developer-access/keys/${encodeURIComponent(keyId)}/rate-limit`,
    data
  )
};

export {
  adminWorkspaceDeveloperApi
};
